module.exports = __webpack_public_path__ + "images/screen-shots/lesson-plan-2ed81f30801e8f7838d788bfbe2025e9.png";